module.exports = __webpack_public_path__ + "img/LIVE-COVER.7df32d37.png";